import store from "@/store";

export function checkDevice(width) {
  if (width < 992) {
    setIsPc(false);
    setIsMobile(true);
    if (width < 768) {
      setIsPhone(true);
    } else {
      setIsPhone(false);
    }
  } else {
    setIsMobile(false);
    setIsPhone(false);
    setIsPc(true);
  }

  if (width > 1300) {
    setIsFullHeader(true);
  } else {
    setIsFullHeader(false);
  }
}

export function setIsPc(state) {
  store.commit("device/setIsPc", state);
}

export function getIsPc() {
  return store.getters["device/getIsPc"];
}

export function setIsMobile(state) {
  store.commit("device/setIsMobile", state);
}

export function getIsMobile() {
  return store.getters["device/getIsMobile"];
}

export function setIsPhone(state) {
  store.commit("device/setIsPhone", state);
}

export function getIsPhone() {
  return store.getters["device/getIsPhone"];
}

export function setIsFullHeader(state) {
  store.commit("device/setIsFullHeader", state);
}

export function getIsFullHeader() {
  return store.getters["device/getIsFullHeader"];
}
